import { X } from "lucide-react";
import { useEffect } from "react";

export default function LegalModal({ open, onClose }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-end justify-center bg-ink/40 backdrop-blur-sm sm:items-center sm:p-6"
      onClick={onClose}
    >
      <div
        className="max-h-[85vh] w-full max-w-2xl overflow-y-auto rounded-t-2xl bg-white p-6 shadow-lift sm:rounded-2xl sm:p-8"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between gap-4">
          <h3 className="text-xl font-semibold text-ink">Mentions légales</h3>
          <button
            type="button"
            onClick={onClose}
            aria-label="Fermer"
            className="rounded-lg p-1.5 text-ink-soft hover:bg-mist hover:text-ink"
          >
            <X size={20} />
          </button>
        </div>

        <div className="mt-5 space-y-4 text-[14.5px] leading-relaxed text-ink-soft">
          <p>
            <strong className="text-ink">Éditeur du site</strong>
            <br />
            [Raison sociale à compléter] — [Forme juridique], au capital de
            [montant] €.
            <br />
            Siège social : [adresse complète].
            <br />
            RCS [ville] [numéro] — SIRET [numéro] — TVA intracommunautaire
            [numéro].
            <br />
            Directeur de la publication : [nom, prénom].
            <br />
            Contact : [email de contact].
          </p>

          <p>
            <strong className="text-ink">Hébergement</strong>
            <br />
            OVH SAS — 2 rue Kellermann, 59100 Roubaix, France.
          </p>

          <p>
            <strong className="text-ink">Propriété intellectuelle</strong>
            <br />
            L'ensemble des contenus présents sur ce site (textes, visuels,
            logo, éléments graphiques) est la propriété exclusive de [raison
            sociale], sauf mention contraire. Toute reproduction, même
            partielle, est interdite sans autorisation préalable.
          </p>

          <p>
            <strong className="text-ink">Données personnelles</strong>
            <br />
            Les informations transmises via le formulaire de contact sont
            utilisées exclusivement pour répondre à votre demande. Conformément
            au RGPD, vous disposez d'un droit d'accès, de rectification et de
            suppression de vos données, exerçable par email à [email de
            contact].
          </p>

          <p className="text-xs text-ink-soft/80">
            Ce texte est un modèle à personnaliser avant mise en ligne : il ne
            constitue pas un conseil juridique.
          </p>
        </div>
      </div>
    </div>
  );
}
